export const COD_TIPO_CFE_E_FACTURA: number = 111;
export const COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA: number = 112;
export const COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA: number = 113;
export const COD_TIPO_CFE_E_TICKET: number = 101;
export const COD_TIPO_CFE_NOTA_CREDITO_E_TICKET: number = 102;
export const COD_TIPO_CFE_NOTA_DEBITO_E_TICKET: number = 103;
export const COD_TIPO_CFE_E_RESGUARDO: number = 182;
export const COD_TIPO_CFE_E_FACTURA_EXP: number = 121;
export const COD_TIPO_CFE_NOTA_CREDITO_E_FACTURA_EXP: number = 122;
export const COD_TIPO_CFE_NOTA_DEBITO_E_FACTURA_EXP: number = 123;
